module.exports = __webpack_public_path__ + "img/job-icon-2.a0ab7708.png";